import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Box, DataGrid, IconButton } from "../../../components";
import { filtrosUrl, PermisoesHelper, value } from "../../../helpers";
import { ListLayout } from "../../../layouts";
import {
  CondicoesPagamentoService,
  history,
  MeioPagamentoService,
  NfSaidaService,
  OperacaoFiscalService,
  PessoaService,
} from "../../../services";
import { formatDate, formatPrice, responseErros } from "../../../utils";
import { NfSaida } from "../entities";
import {
  BaixarXmlDialog,
  DevolverMercadoriaDialog,
  DevolverMercadoriaFornecedorDialog,
  FormFiltroAvancado,
  ImportarCondicionalDialog,
  ImportarDocumentoDialog,
  ImportarOrcamentoDialog,
  ImportarPedidoDialog,
  InutilizacaoDfeDialog,
  MenuSuperiorLista,
  NfeComplementarDialog,
} from "./components";
import { obterIconeStatus } from "./list-nf-saida";
const nfSaidaService = new NfSaidaService();
const operacaoFiscalService = new OperacaoFiscalService();
const pessoaService = new PessoaService();
const meiosDePagamentoService = new MeioPagamentoService();
const condicoesDeVendaService = new CondicoesPagamentoService();

const ListNfSaidaView = () => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("nf-saida-visualizar");
  const [loading, setLoading] = useState(false);
  const [nfsSaida, setNfsSaida] = useState([]);
  const [nfSaida, setNfSaida] = useState({});
  const [listaPessoas, setListaPessoas] = useState([]);
  const [linhasSelecionadas, setLinhasSelecionadas] = useState([]);
  const [listaOperacoesFiscais, setListaOperacoesFiscais] = useState([]);
  const [listaMeiosPagamento, setListaMeiosPagamento] = useState([]);
  const [rowCount, setRowCount] = useState(null);
  const [listaCondicoesVenda, setListaCondicoesVenda] = useState([]);
  const [documentoSelectionModel, setDocumentoSelectionModel] = useState([]);
  const [openImportarCondicionalDialog, setOpenImportarCondicionalDialog] =
    useState(false);
  const [openImportarOrcamentoDialog, setOpenImportarOrcamentoDialog] =
    useState(false);
  const [openImportarPedidoDialog, setOpenImportarPedidoDialog] =
    useState(false);
  const [openDevolverMercadoriaDialog, setOpenDevolverMercadoriaDialog] =
    useState(false);
  const [openImportarDocumentoDialog, setOpenImportarDocumentoDialog] =
    useState(false);
  const [
    openDevolverMercadoriaFornecedorDialog,
    setOpenDevolverMercadoriaFornecedorDialog,
  ] = useState(false);
  const [filtrosDialog, setFiltrosDialog] = useState({});
  const [openNfeComplementarDialog, setOpenNfeComplementarDialog] =
    useState(false);
  const [openInutilizacaoDfeDialog, setOpenInutilizacaoDfeDialog] =
    useState(false);
  const [openBaixarXmlDialog, setOpenBaixarXmlDialog] = useState(false);
  const status = [
    {
      id: 1,
      nome: "Enviada",
      cor: "#4FBB53",
    },
    {
      id: 2,
      nome: "Faturada",
      cor: "#004780",
    },
    {
      id: 3,
      nome: "Pendente",
      cor: "#EA9D2B",
    },
    {
      id: 4,
      nome: "Cancelada",
      cor: "#DC3545",
    },
    {
      id: 5,
      nome: "Em Contigência",
      cor: "#BFBFBF",
    },
    {
      id: 6,
      nome: "Denegada",
      cor: "#70309F",
    },
    {
      id: 7,
      nome: "Em Processamento",
      cor: "#A0522D",
    },
  ];

  const buttonSelectOpcoes = [
    { permission: true, descricao: "Importar Condicional" },
    { permission: true, descricao: "Importar Orçamento" },
    { permission: true, descricao: "Importar Pedido" },
    { permission: true, descricao: "Importar Documento" },
    { permission: true, descricao: "Devolução de Mercadoria do Cliente" },
    { permission: true, descricao: "Devolução de Mercadoria ao Fornecedor" },
    { permission: true, descricao: "Documento de Transferência" },
    { permission: true, descricao: "NF-e Complementar" },
    { permission: true, descricao: "NF-e de Ajuste" },
    { permission: true, descricao: "Operação de Entrada" },
    { permission: true, descricao: "Inutilização de DF-e" },
  ];

  const colunas = [
    {
      field: "status",
      headerName: "Status",
      sortable: true,
      flex: 100,
      renderCell: (params) => obterIconeStatus(params.value),
    },
    {
      field: "serieDocumento",
      headerName: "Série",
      width: 100,
      valueGetter: (params) => value.text(params.value),
    },
    {
      field: "numeroDocumento",
      headerName: "Nº Documento",
      flex: 170,
      filtrar: true,
    },
    {
      field: "operacaoFiscalId",
      headerName: "Operação Fiscal",
      flex: 250,
      valueGetter: (params) =>
        listaOperacoesFiscais.find((item) => item.id == params.value)
          ?.descricao,
    },
    {
      field: "createdAt",
      headerName: "Data de Lançamento",
      width: 200,
      valueGetter: (params) =>
        format(formatDate.received(params.value), "dd/MM/yyyy"),
    },
    {
      field: "clienteNome",
      headerName: "Cliente",
      width: 300,
      sortable: false,
      valueGetter: (params) =>
        params.value ??
        listaPessoas.find((item) => item.id == params.row.clienteId)
          ?.nomeRazaoSocial,
    },
    {
      field: "nfSaidaItens",
      headerName: "Total da Venda",
      flex: 250,
      sortable: false,
      valueGetter: (params) => {
        const totalItensDespesasNfSaida =
          params.value
            .map((item) => item.subtotal)
            .reduce((acumulador, total) => acumulador + total, 0) -
          params.row.desconto +
          params.row.despesas +
          (params.row.subtotalTributosIncidentes || 0);
        const totalNfSaida = params.row.freteCompoeNota
          ? totalItensDespesasNfSaida + params.row.frete
          : totalItensDespesasNfSaida;
        return formatPrice(totalNfSaida);
      },
    },
  ];

  useEffect(() => {
    const filtros = filtrosUrl.get();
    buscarNfSaida(filtros);
  }, []);

  const buscarNfSaida = async function (filtro) {
    setLoading(true);
    const result = await nfSaidaService.getAll(filtro);
    if (!result.isAxiosError) {
      setNfsSaida(result.data.rows);
      setRowCount(result.data.count);
      buscarRelacionamentosNfsSaida(result.data.rows);
      filtrosUrl.set(filtro);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarRelacionamentosNfsSaida = (listaDocumentos) => {
    const idsPessoas = [];
    const idsOperacoesFiscais = [];
    const idsMeiosPagamento = [];
    const idsCondicoesVenda = [];
    for (const objeto of listaDocumentos) {
      idsOperacoesFiscais.push(objeto.operacaoFiscalId);
      if (objeto.clienteId) idsPessoas.push(objeto.clienteId);
      if (objeto.condicaoPagamentoId)
        idsCondicoesVenda.push(objeto.condicaoPagamentoId);
      if (objeto.meioPagamentoId)
        idsMeiosPagamento.push(objeto.meioPagamentoId);
    }
    const idsUnicosOperacoesFiscais = [...new Set(idsOperacoesFiscais)];
    const idsUnicosPessoas = [...new Set(idsPessoas)];
    const idsUnicosCondicoesVenda = [...new Set(idsPessoas)];
    const idsUnicosMeiosPagamento = [...new Set(idsPessoas)];
    buscarOperacoesFiscais(idsUnicosOperacoesFiscais);
    buscarPessoas(idsUnicosPessoas);
    buscarMeiosPagamento(idsUnicosMeiosPagamento);
    buscarCondicoesVenda(idsUnicosCondicoesVenda);
  };

  const buscarOperacoesFiscais = (listaIds) => {
    const filtro = {
      id: listaIds.length > 0 ? listaIds : undefined,
      nonPaginated: true,
    };
    operacaoFiscalService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaOperacoesFiscais(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarPessoas = (listaIds) => {
    const filtro = {
      id: listaIds.length > 0 ? listaIds : undefined,
      nonPaginated: true,
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        const listaPessoas = result.data;
        setListaPessoas(listaPessoas);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarMeiosPagamento = (listaIds) => {
    const filtro = {
      id: listaIds.length > 0 ? listaIds : undefined,
      nonPaginated: true,
    };
    meiosDePagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaMeiosPagamento(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarCondicoesVenda = (listaIds) => {
    const filtro = {
      id: listaIds.length > 0 ? listaIds : undefined,
      nonPaginated: true,
    };
    condicoesDeVendaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaCondicoesVenda(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const onClickCadastrarNfSaida = function (descricao) {
    switch (descricao) {
      case "Importar Condicional":
        setOpenImportarCondicionalDialog(true);
        break;
      case "Importar Orçamento":
        setOpenImportarOrcamentoDialog(true);
        break;
      case "Importar Pedido":
        setOpenImportarPedidoDialog(true);
        break;
      case "Importar Documento":
        setOpenImportarDocumentoDialog(true);
        break;
      case "Devolução de Mercadoria do Cliente":
        setOpenDevolverMercadoriaDialog(true);
        break;
      case "Devolução de Mercadoria ao Fornecedor":
        setOpenDevolverMercadoriaFornecedorDialog(true);
        break;
      case "Documento de Transferência":
        window.nfSaidaEntity = new NfSaida({
          transferencia: true,
        });
        history.push("/faturamento/nf-saida/transferencia");
        break;
      case "NF-e Complementar":
        setNfSaida({
          finalidade: "finalNfeComplementar",
        });
        setOpenNfeComplementarDialog(true);
        break;
      case "Inutilização de DF-e":
        setOpenInutilizacaoDfeDialog(true);
        break;
      case "NF-e de Ajuste":
        setNfSaida({
          finalidade: "finalNfeAjuste",
        });
        setOpenNfeComplementarDialog(true);
        break;
      case "Operação de Entrada":
        window.nfSaidaEntity = new NfSaida({
          operacaoEntrada: true,
        });
        history.push("/faturamento/nf-saida/operacao-entrada");
        break;
      default:
        history.push("/faturamento/nf-saida/create");
        break;
    }
  };

  const onClickEditNfSaida = function (id) {
    history.push(`/faturamento/nf-saida/${id}`);
  };

  const buscarPesquisaAvancada = async (filter) => {
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    if (
      filtrosAvancadosTemp.dataEmissaoStart &&
      filtrosAvancadosTemp.dataEmissaoEnd
    ) {
      porIntervalo.push({
        coluna: "dataEmissao",
        de: filtrosAvancadosTemp.dataEmissaoStart,
        ate: filtrosAvancadosTemp.dataEmissaoEnd,
      });
    }
    if (
      filtrosAvancadosTemp.dataLancamentoStart &&
      filtrosAvancadosTemp.dataLancamentoEnd
    ) {
      porIntervalo.push({
        coluna: "createdAt",
        de: filtrosAvancadosTemp.dataLancamentoStart,
        ate: filtrosAvancadosTemp.dataLancamentoEnd,
      });
    }
    if (filtrosAvancadosTemp.totalStart && filtrosAvancadosTemp.totalEnd) {
      porIntervalo.push({
        coluna: "totalVenda",
        de: parseFloat(filtrosAvancadosTemp.totalStart),
        ate: parseFloat(filtrosAvancadosTemp.totalEnd),
      });
    }
    delete filtrosAvancadosTemp.dataEmissaoStart;
    delete filtrosAvancadosTemp.dataEmissaoEnd;
    delete filtrosAvancadosTemp.dataLancamentoStart;
    delete filtrosAvancadosTemp.dataLancamentoEnd;
    delete filtrosAvancadosTemp.totalStart;
    delete filtrosAvancadosTemp.totalEnd;
    setLoading(true);
    const result = await nfSaidaService.getAllFiltroAvancado({
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
    });
    if (!result.isAxiosError) {
      setNfsSaida(result.data.rows);
      setRowCount(result.data.count);
      buscarRelacionamentosNfsSaida(result.data.rows);
      filtrosUrl.set(filter);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarNfSaida(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  const renderReloadAction = () => {
    const filtros = filtrosUrl.get();
    return (
      <Box sx={{ml: 3}}>
        <IconButton
          onClick={() =>  buscarNfSaida(filtros)}
          sx={{
            backgroundColor: "#EDEEF0",
            "&:hover": { backgroundColor: "#B6BABC" },
          }}
        >
          <i
            className="ph-fill ph-arrows-clockwise"
            style={{ fontSize: 22 }}
          ></i>
        </IconButton>
      </Box>
    );
  }

  return (
    <ListLayout
      title="Nf's de Saida"
      loading={loading}
      onClickCadastrar={onClickCadastrarNfSaida}
      buttonSelectOpcoes={buttonSelectOpcoes}
      permissaoButton={permissoesHelper.temPermisao("nf-saida-cadastrar")}
      listaStatus={status}
      ButtonMenu={
        <MenuSuperiorLista
          data={linhasSelecionadas}
          setOpenBaixarXmlDialog={setOpenBaixarXmlDialog}
        />
      }
    >
      <DataGrid
        checkboxSelection={true}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setLinhasSelecionadas(newRowSelectionModel);
        }}
        rows={nfsSaida}
        columns={colunas}
        onClickEdit={onClickEditNfSaida}
        visualizarShow={permissoesHelper.temPermisao("nf-entrada-visualizar")}
        editShow={permissoesHelper.temPermisao("nf-entrada-editar")}
        paginationMode={"server"}
        rowCount={rowCount}
        sendServer={sendServerDatagrid}
        FormFiltroAvancado={FormFiltroAvancado}
        extraActions={renderReloadAction()}
      />
      <ImportarOrcamentoDialog
        openImportarOrcamentoDialog={openImportarOrcamentoDialog}
        setOpenImportarOrcamentoDialog={setOpenImportarOrcamentoDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
      />
      <ImportarPedidoDialog
        openImportarPedidoDialog={openImportarPedidoDialog}
        setOpenImportarPedidoDialog={setOpenImportarPedidoDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
      />
      <ImportarDocumentoDialog
        openImportarDocumentoDialog={openImportarDocumentoDialog}
        setOpenImportarDocumentoDialog={setOpenImportarDocumentoDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
        buscarNfSaida={buscarNfSaida}
        buscarNfSaidaAvancado={buscarPesquisaAvancada}
        listaPessoas={listaPessoas}
        listaCondicoesVenda={listaCondicoesVenda}
        listaMeiosPagamento={listaMeiosPagamento}
        listaOperacoesFiscaisIniciais={listaOperacoesFiscais}
        setLoading={setLoading}
        documentoSelectionModel={documentoSelectionModel}
        setDocumentoSelectionModel={setDocumentoSelectionModel}
      />
      <DevolverMercadoriaDialog
        openDevolverMercadoriaDialog={openDevolverMercadoriaDialog}
        setOpenDevolverMercadoriaDialog={setOpenDevolverMercadoriaDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
        buscarNfSaida={buscarNfSaida}
        buscarNfSaidaAvancado={buscarPesquisaAvancada}
        listaPessoas={listaPessoas}
        listaCondicoesVenda={listaCondicoesVenda}
        listaMeiosPagamento={listaMeiosPagamento}
        nfsSaida={nfsSaida}
        listaOperacoesFiscaisIniciais={listaOperacoesFiscais}
      />
      <DevolverMercadoriaFornecedorDialog
        openDevolverMercadoriaFornecedorDialog={
          openDevolverMercadoriaFornecedorDialog
        }
        setOpenDevolverMercadoriaFornecedorDialog={
          setOpenDevolverMercadoriaFornecedorDialog
        }
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
      />
      <NfeComplementarDialog
        openNfeComplementarDialog={openNfeComplementarDialog}
        setOpenNfeComplementarDialog={setOpenNfeComplementarDialog}
        nfSaida={nfSaida}
        setNfSaida={setNfSaida}
        setLoading={setLoading}
      />
      <InutilizacaoDfeDialog
        openInutilizacaoDfeDialog={openInutilizacaoDfeDialog}
        setOpenInutilizacaoDfeDialog={setOpenInutilizacaoDfeDialog}
        setLoading={setLoading}
      />
      <BaixarXmlDialog
        openBaixarXmlDialog={openBaixarXmlDialog}
        setOpenBaixarXmlDialog={setOpenBaixarXmlDialog}
      />
      <ImportarCondicionalDialog
        openImportarCondicionalDialog={openImportarCondicionalDialog}
        setOpenImportarCondicionalDialog={setOpenImportarCondicionalDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
        listaOperacoesFiscais={listaOperacoesFiscais}
      />
    </ListLayout>
  );
};

export default ListNfSaidaView;
